import styled from 'styled-components';

export const StyledLoginLayoutWrapper = styled.div`
  min-height: 100vh;
  background: var(--paper);
  display: flex;
  overflow-x: hidden;
`;
